<template>
  <div id="tabs-maneuvering-data">
    <vs-tabs
      vs-alignment="fixed"
      alignment="fixed"
      :color="sdfColor.LightGreen"
    >
      <vs-tab label="動静データ">
        <tab-status/>
      </vs-tab>
      <vs-tab label="操船データ">
        <tab-maneuvering/>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import SecureDataflowMixin from "@/mixins/SecureDataflowMixin";
import TabStatus from "./tab-vessel-moving-status/TabVesselMovingStatus.vue";
import TabManeuvering from "./tab-vessel-maneuvering-status/TabVesselManeuveringStatus.vue";

import {
  StoreMonitoringVesselManeuveringMixin
} from "@/mixins/addon/secure-dataflow";

export default {
  mixins: [SecureDataflowMixin, StoreMonitoringVesselManeuveringMixin],
  components: {
    TabStatus,
    TabManeuvering
  },
  data() {
    return {
      liveVesselData: [],
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
        timeoutIdManeuvering: null,
        timeoutIdEngine: null
      },
    };
  },
  watch: {
    channelDataManeuvering(channelDataManeuvering) {
      this.setCheckChannelDataManeuveringLastUpdate()
    },
    channelDataEngine(channelDataEngine) {
      this.setCheckChannelDataEngineLastUpdate()
    }
  },
  computed: {},
  methods: {
    setCheckChannelDataManeuveringLastUpdate() {
      if (this.timeoutIdManeuvering) {
        clearTimeout(this.timeoutIdManeuvering)
      } else {
        this.checkChannelDataManeuveringLastUpdate()
      }
      this.timeoutIdManeuvering = setTimeout(() => {
        this.checkChannelDataManeuveringLastUpdate()
      }, 180000)
    },

    setCheckChannelDataEngineLastUpdate() {
      if (this.timeoutIdEngine) {
        clearTimeout(this.timeoutIdEngine)
      } else {
        this.checkChannelDataEngineLastUpdate()
      }
      this.timeoutIdEngine = setTimeout(() => {
        this.checkChannelDataEngineLastUpdate()
      }, 180000)
    },
  },
  mounted() {
  },
  beforeDestroy() {
    if (this.timeoutIdManeuvering) {
      clearTimeout(this.timeoutIdManeuvering)
      this.timeoutIdManeuvering = null
    }
    if (this.timeoutIdEngine !== null) {
      clearTimeout(this.timeoutIdEngine)
      this.timeoutIdEngine = null
    }
  }
}
</script>

<style lang="scss">
</style>
